<template>
    <v-button
        @click="$emit('click', $event)"
        :theme="theme" :block="block"
        :primary="primary"
        :raised="raised"
        :flat="flat"
        :type="type"
        :disabled="disabled"
    >
        <slot></slot>
    </v-button>
</template>
<script>
    import theme from './theme.scss';

    export default {
        name: 'sign-button',
        props: {
            type: String,
            disabled: Boolean,
            primary: Boolean,
            raised: {
                type: Boolean,
                default: true,
            },
            flat: {
                type: Boolean,
                default: false,
            },
            ripple: {
                type: Boolean,
                default: true,
            },
            block: {
                type: Boolean,
                default: false,
            },
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Button.vue?1da89828